// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.dbc-material-full-width {
  width: 100%;
}

.table_mat_inp {
  padding: 0;
  font-size: 14px !important;
}

::ng-deep .table_mat_inp > .mat-form-field-wrapper > .mat-form-field-flex > .mat-form-field-infix {
  padding: 0 !important;
}

.change-highlight {
  color: orange !important;
}

.row-imported {
  background-color: #fff3cd !important;
  box-shadow: inset 4px 0 0 #f0ad4e;
}

td {
  text-align: center;
  vertical-align: middle;
}

input[type=text] {
  border: 0;
  border-bottom: 2px solid;
  text-align: center;
}

.touched {
  border-bottom-color: #1e82ae !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=text]:focus {
  outline: none;
}

select.mySelectArrow {
  appearance: none;
  outline: 1px solid;
  border-radius: 5px;
  border: none;
  color: #1e82ae;
  width: 100%;
  padding: 5px 5px;
  font-size: 15px;
}

select.mySelectArrow option {
  color: #000;
  padding: 10px;
}

.select:after {
  content: "▼";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  font-size: 15px;
  border: none;
  outline-color: #1e82ae;
  color: #000;
  padding: 7px 10px 5px;
  pointer-events: none;
}

.select {
  position: relative;
  width: 220px;
}

.my-footer {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
}

.btns-ft {
  min-width: 75% !important;
}

.file-up {
  min-width: 25%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.fxRow {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 10em;
}

.text-area {
  width: 100%;
  min-height: 6em;
  max-height: 6em;
  overflow: scroll;
}

.selecto {
  padding: 3px 20px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/modals/price-list-edit-modal/price-list-edit-modal.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,WAAA;AAEJ;;AACA;EACI,UAAA;EACA,0BAAA;AAEJ;;AACC;EACG,qBAAA;AAEJ;;AACA;EACI,wBAAA;AAEJ;;AAEA;EACI,oCAAA;EACA,iCAAA;AACJ;;AAEA;EACI,kBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,SAAA;EACA,wBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,uCAAA;AACJ;;AAEA;;EAEI,wBAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EAGI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EAEA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,WAAA;EACA,aAAA;AAAJ;;AAGA;EACI,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,yBAAA;AAAJ;;AAGA;EACI,cAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAAJ;;AAGA;EACI,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,4BAAA;AAAJ","sourcesContent":[".dbc-material-full-width {\n    width: 100%;\n}\n\n.table_mat_inp {\n    padding: 0;\n    font-size: 14px !important;\n}\n\n ::ng-deep .table_mat_inp>.mat-form-field-wrapper>.mat-form-field-flex>.mat-form-field-infix {\n    padding: 0 !important;\n}\n\n.change-highlight {\n    color: orange !important;\n}\n\n// Rows whose prices were changed by the most recent import.\n.row-imported {\n    background-color: #fff3cd !important;\n    box-shadow: inset 4px 0 0 #f0ad4e;\n}\n\ntd {\n    text-align: center;\n    vertical-align: middle;\n}\n\ninput[type=text] {\n    border: 0;\n    border-bottom: 2px solid;\n    text-align: center;\n}\n\n.touched {\n    border-bottom-color: #1e82ae!important;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\ninput[type=text]:focus {\n    outline: none;\n}\n\nselect.mySelectArrow {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    outline: 1px solid;\n    border-radius: 5px;\n    border: none;\n    // outline-color: #1e82ae;\n    color: #1e82ae;\n    width: 100%;\n    padding: 5px 5px;\n    font-size: 15px;\n}\n\nselect.mySelectArrow option {\n    color: #000;\n    padding: 10px;\n}\n\n.select:after {\n    content: '\\25BC';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    font-size: 15px;\n    border: none;\n    outline-color: #1e82ae;\n    color: #000;\n    padding: 7px 10px 5px;\n    pointer-events: none;\n}\n\n.select {\n    position: relative;\n    width: 220px;\n}\n\n.my-footer {\n    min-height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: nowrap;\n}\n\n.btns-ft {\n    min-width: 75%!important;\n}\n\n.file-up {\n    min-width: 25%;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n.fxRow {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: row;\n    gap: 10em;\n}\n\n.text-area {\n    width: 100%;\n    min-height: 6em;\n    max-height: 6em;\n    overflow: scroll;\n}\n\n.selecto {\n    padding: 3px 20px!important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
